<div mat-dialog-title>
  <span *ngIf="!data.renameList">Create New</span>
  <span *ngIf="data.renameList">Rename</span> Favorites List
  <div class="dialog-close-button">
    <a (click)="onClose()" id="close">
      <img src="/assets/images/close-popup.png">
    </a>
  </div>
</div>
<form class="fav-form" (ngSubmit)="onSubmit()" #favForm="ngForm">
  <div mat-dialog-content cdkFocusInitial>
    <mat-form-field class="full-width">
      <input id="fav-name" matInput name="favName" #favName="ngModel" required maxlength="19" placeholder="List name" [(ngModel)]="favNameText"
        (ngModelChange)="checkMaxLength($event)">
    </mat-form-field>
    <div class="mat-error" *ngIf="favName.errors?.required && favForm.submitted">Please enter a list name.</div>
    <div class="mat-error" *ngIf="duplicateName && favForm.submitted && !favName.errors?.required  && !maxLength">A list with this name already exists. Please enter a different name.</div>
    <div class="mat-error" *ngIf="maxLength"> Favorites list name must be 18 characters or fewer.</div>
  </div>
  <div mat-dialog-actions>
    <span *ngIf="!data.renameList">
      <button mat-raised-button type="submit" id="btn-submit">Create new list</button>
      <button mat-raised-button [mat-dialog-close]="false" id="btn-close">Cancel</button>
    </span>
    <span *ngIf="data.renameList">
      <button mat-raised-button type="submit" id="btn-submit">Rename list</button>
      <button mat-raised-button [mat-dialog-close]="false" id="btn-close">Close</button>
    </span>
  </div>
</form>